import store from '../store';
import Whatsapp from '../views/whatsapp/Index.vue';
import { checkauth } from '../Helper';

export default [
	{
		path: '/whatsapp',
		name: 'whatsapp',
		component: Whatsapp,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
];
